import { CustomerAddress } from '@app-types/delivery';

export function PrintAddress({ address }: Readonly<{ address: CustomerAddress }>) {
    return (
        <p id='deliveryContent'>
            {address.streetNumber} {address.streetName}
            <br />
            {address.postalCode}, {address.city}
            {address.complementaryAddress && (
                <>
                    <br />
                    {address.complementaryAddress}
                </>
            )}
        </p>
    );
}
